/* eslint-disable complexity */
import React from 'react';
import { hackyServerSideTranslations } from '../../i18nNext';
import { buildGuestOrLoggedInLayout } from '../../components/layout/layoutBuilder';
import Missions from '../../components/search/Missions';
import { buildSimpleHead } from '../../components/layout/heading';
import { useTranslate } from '../../translate/I18n';
import { array, arrayOf, number, object } from 'prop-types';
import { MISSION } from '../../constants';
import {
  getMissionLocations,
  getRoles,
  searchMissions
} from '../../store/missions/missions.service';
import { extractFiltersFromUrl, getAllRegionsSlugs, updateFiltersWithPreferences, updateFiltersWithUrlParams } from '../../components/search/searchUtils';

const {
  ORDERS: { LAST_UPDATE_TIME }
} = MISSION;

const SearchPage = ({ missions, totalCount, initialFilters, missionsLocations, roles }) => {
  return <Missions
    preloadedMissions={missions}
    preloadedTotalCount={totalCount}
    initialFilters={initialFilters}
    missionsLocations={missionsLocations}
    roles={roles}
  />;
};

SearchPage.getHead = () => props => {
  const { t } = useTranslate(['common']);

  const DefaultHeader = buildSimpleHead('general-connected');

  return (
    <DefaultHeader
      {...props}
      title={t('common:missionSearch')}
    />
  );
};

SearchPage.propTypes = {
  missions: arrayOf(object),
  totalCount: number,
  initialFilters: object,
  missionsLocations: array,
  roles: array
};

export async function getStaticPaths(params) {
  let pathsAndLocale = [];
  params.locales.forEach(locale => {
      pathsAndLocale.push({
        params: {
          search: []
        },
        locale
      });
  });

  return {
    paths: pathsAndLocale,
    fallback: 'blocking'
  };
}

export async function getStaticProps({ locale, params }) {

  const i18nConfig = await hackyServerSideTranslations(locale, [
    'betaBanner',
    'common',
    'companyProfile',
    'discord',
    'footer',
    'home',
    'legal',
    'locations',
    'mission',
    'metaData',
    'profile',
    'sectors',
    'settings',
    'skill',
    'verifyAccount'
  ]
  );

  const { searchValue, locations, role, orderBy, minDailyRate, currency, hasFiltersInUrl } = extractFiltersFromUrl(params.search);

  let filters = {
    orderBy: LAST_UPDATE_TIME,
    page: 0,
    isPaginated: false,
    searchValue: '',
    role: '',
    currency: 'EUR'
  };

  const { preferences } = {};
  const missionsLocations = await getMissionLocations({ role: filters.role });
  const roles = await getRoles({ locations: filters.locations });
  const listOfRoleLabels = roles.map(role => role.role);
  const listOfAllRegionSlug = getAllRegionsSlugs(missionsLocations);

  if (preferences && !hasFiltersInUrl) {
    filters = updateFiltersWithPreferences(preferences, filters, missionsLocations, listOfAllRegionSlug);
  }

  //filters in the Url override every other filters
  if (hasFiltersInUrl) {
    filters = updateFiltersWithUrlParams({ orderBy, searchValue, role, locations, minDailyRate, currency }, filters, listOfRoleLabels, missionsLocations);
  }

  const { missions, totalCount } = await searchMissions(filters, null);

  try {
    return {
      props: {
        ...i18nConfig,
        initialFilters: filters,
        missions,
        totalCount,
        missionsLocations,
        roles
      }
    };
  } catch (e) {
    return { props: { ...i18nConfig }, notFound: true };
  }
}

SearchPage.getLayout = buildGuestOrLoggedInLayout();
export default SearchPage;
